import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	useAsSubOption: ForNodeType<boolean>;

	isNextMorning: ForNodeType<boolean>;
	onSetIsNextMorning: (value: boolean) => void;

	isEdited: boolean;
	hasError: boolean;

	title?: string;
	guide?: string;
};

export const QuestionIsNextMorning = ({
	useAsSubOption,

	isNextMorning,
	onSetIsNextMorning,

	isEdited,
	hasError,

	title: _title,
	guide: _guide,
}: Props) => {
	const title = _title || "翌朝のオプション";
	const guide =
		_guide ||
		"朝食など、予約日を基準として、<br />体験日時が翌日となるオプションはチェックをつけてください。<br />※サブオプションがある場合はサブオプションでの設定が優先されます";

	return (
		<>
			{useAsSubOption.value ? (
				<div>
					<p>サブオプションの場合、「 特殊なオプション属性 」で設定できる項目はありません</p>
				</div>
			) : (
				<FeatureIslandCategoryQuestionForMain
					required={false}
					title={title}
					guide={guide}
					isEdited={isEdited}
					hasError={hasError}
					inputChildren={
						<CheckboxField
							value={isNextMorning.value}
							label={"翌朝のオプションとして設定する"}
							handleChange={onSetIsNextMorning}
							errorMessage={isNextMorning.error}
						/>
					}
				/>
			)}
		</>
	);
};

QuestionIsNextMorning.displayName = "QuestionIsNextMorning";
